import React from 'react';
import { NavLink } from 'react-router-dom';
import { Icon } from '@components/generic/Icon';
import { animated, useSpring } from 'react-spring';
import { useTheme } from '@hooks/theme';
import { ReactComponent as LogoMini } from '@assets/images/logo-fpa-mini.svg';
import { ReactComponent as Logo } from '@assets/images/logo-e-pu.svg';
import { Switch } from '@components/generic/Switch';

import { useAuth } from '@hooks/auth';
import { getPaths } from '../../../paths';

import { Container, Footer, Menu, Retract } from './styles';

interface SidebarProps {
  handleRetract(): void;
  isRetract: boolean;
}

export const Sidebar: React.FC<SidebarProps> = ({
  handleRetract,
  isRetract,
}) => {
  const fadeIn = useSpring({
    opacity: 1,
    from: { opacity: 0 },
    config: {
      duration: 300,
    },
  });

  const svgWidth = useSpring({
    width: isRetract ? '1.2rem' : '10.6rem',
    config: {
      duration: 300,
    },
  });

  const { signOut, user } = useAuth();

  const dataPaths = user ? getPaths(user.groupUser) : null;

  const { changeTheme, theme } = useTheme();

  return (
    <Container isRetract={isRetract}>
      <animated.div style={svgWidth}>
        {isRetract ? <LogoMini /> : <Logo />}
      </animated.div>

      {/* <Retract onClick={handleRetract} isRetract={isRetract}>
        <Icon name="chevron" color="textWhite" size="xsm" />
      </Retract> */}

      <Menu isRetract={isRetract}>
        {dataPaths &&
          dataPaths.map((path: any) => {
            return (
              <animated.li style={fadeIn} key={path.name}>
                <NavLink to={path.path} className={path.name.toLowerCase()}>
                  <div>
                    <Icon name={path.icon} color="itemMenuActive" />
                    <p className="p1 ifpa-medium">{path.name}</p>
                  </div>
                </NavLink>
              </animated.li>
            );
          })}
      </Menu>

      <Footer isRetract={isRetract}>
        <div>
          <Switch checked={theme !== 'light'} onClick={changeTheme} />
          {isRetract ? (
            <Icon name="moon" color="textWhite" />
          ) : (
            <p className="p1 ifpa-medium">Modo Escuro</p>
          )}
        </div>
        <hr />
        <button type="button" onClick={() => signOut()}>
          <Icon name="logout" color="textWhite" />
          {!isRetract && <p className="p1 ifpa-medium">Sair</p>}
        </button>
        <hr />
        {/* <div style={{ marginBottom: 20 }} /> */}
      </Footer>
    </Container>
  );
};
